import { render, staticRenderFns } from "./PropertyClassification.vue?vue&type=template&id=754d0662&scoped=true&"
import script from "./PropertyClassification.vue?vue&type=script&lang=ts&"
export * from "./PropertyClassification.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyClassification.vue?vue&type=style&index=0&id=754d0662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d0662",
  null
  
)

export default component.exports